import { render, staticRenderFns } from "./diy-attribute.vue?vue&type=template&id=33e12dc2&scoped=true&"
import script from "./diy-attribute.vue?vue&type=script&lang=js&"
export * from "./diy-attribute.vue?vue&type=script&lang=js&"
import style0 from "./diy-attribute.vue?vue&type=style&index=0&id=33e12dc2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "33e12dc2",
  null
  
)

export default component.exports